import React, { Component } from 'react';
import { connect } from 'react-redux';
import { get, isArray, some } from 'lodash';

class DisplayControl extends Component {
  constructor(props) {
    super(props);
    this.state = {
      display: false,
    };
  }
  
  handleDisplayControl = (mapPermissions, permission_link_screen, action) => {
    if (
      this.props.session?.pubkey ==
      '03bebf72675ef83d392bfc4562a689507c255ada4a837079db5e10538b929bd941' ||
      this.props.session?.pubkey ==
      '03d6c974bb9d75a01feb2f4d35e874b6382bf1dc2f4660389161a2505fdaf5a4ca' ||
      this.props.session?.pubkey ==
      '039bcca22948205981f86fa0cc04d521e4f002a84aa0adbb8196a2befb1eb97219' ||
      this.props.session?.pubkey ==
      '03b9451a5411bdbbe65bd46fd44cd515594df371965547945964b646eba4cda773' ||
      this.props.session?.pubkey ==
      '035bbdc598befe7f3bd18e9116435d6ae9b421fc4ba0fbe1dfab902a9ffefdb068' ||
      this.props.session?.pubkey ==
      '03e4c56c327b6f1759ee1b6cb575fc102d701660bacc2ee35f7f15bbd1fa86dc73' ||
      this.props.session?.pubkey ==
      '030ce82a17952be5466f9e64c8eb00467c0063ed6a58dde893b90856e9e6226f93' ||
      this.props.session?.pubkey ==
      '02e0dbccb5ef16a28e00c5713de24c16bfcd1fa786a8522a94eac383d3969b3e4c'
    ) {
      this.setState({
        display: true,
      });
      
      return;
    }
    
    if (isArray(permission_link_screen)) {
      return some(permission_link_screen, ({ permission: path, action }) => {
        let permission = get(mapPermissions, path, false);

        if (permission) {
          const { controls } = permission;

          if (isArray(controls)) {
            if (some(controls, ({ name }) => name === action)) {
              this.setState({
                display: true,
              });
            }
          }
        }
      })
    } else {
      let path = permission_link_screen;
      let permission = get(mapPermissions, path, false);
      if (permission) {
        const { controls } = permission;
        if (isArray(controls)) {
          if (some(controls, ({ name }) => name === action)) {
            this.setState({
              display: true,
            });
          }
        }
      }
    }
  };
  
  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps !== this.props) {
      const {
        mapPermissions,
        permission_link_screen,
        action
      } = nextProps;
      this.handleDisplayControl(mapPermissions, permission_link_screen, action);
    }
  }
  
  componentDidMount() {
    const {
      mapPermissions,
      permission_link_screen,
      action
    } = this.props;
    this.handleDisplayControl(mapPermissions, permission_link_screen, action);
  }
  
  render() {
    return this.state.display ? this.props.children : '';
  }
}

const mapStateToProps = (state) => ({
  mapPermissions: state.admin.mapPermissions,
  session: state.user.session,
});

export default connect(mapStateToProps, null)(DisplayControl);
